// extracted by mini-css-extract-plugin
export var dropdownButton = "_16-0";
export var fullWidthDropdownButton = "_16-1";
export var icon = "_16-3";
export var iconPlaceholder = "_16-2";
export var menuItemRow = "_16-5";
export var shortcutContainer = "_16-4";